import { useCurrentUser } from './useCurrentUser';

export const useClientId = () => {
  const currentUser = useCurrentUser();
  return currentUser.client;
};
